import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import {
	LocalizeNameSpaceTypes,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import { dataBoxLabel, getDataBoxTypeLabel } from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { useDataBoxStoreLists } from '@gov-nx/store';

interface DataboxSettingsHeadingProps {
	databoxId: string;
}

export const DataboxSettingsHeading = ({
	databoxId,
}: DataboxSettingsHeadingProps) => {
	const { getDataBoxById } = useDataBoxStoreLists();
	const databox = getDataBoxById(databoxId);

	const { getLocalizeCurried } = useTranslationWithNamespace();
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	const tds = getLocalizeCurried(PageCode['datove-schranky']);

	if (!databox) {
		return (
			<GovSkeleton
				height="28px"
				width="70%"
				className="py-2"
				aria-label={t('loading.wcag.processing')}
			/>
		);
	}

	return (
		<h3
			id={`databox-notification-settings-label_${databoxId}`}
			className="text-body-l! text-(--text-secondary)">
			<strong>{dataBoxLabel(databox, true)}&nbsp;</strong>
			&ndash; {getDataBoxTypeLabel(databox.typSchranky, tds)}
			{` (${databoxId})`}
		</h3>
	);
};
